import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Modal } from './Modal';
import { SignupForm } from './SignupForm';
type Plan = {
  name: string;
  price: string;
  period: string;
  features: string[];
  cta: string;
  featured: boolean;
};
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  const plans: Plan[] = [{
    name: 'Starter',
    price: '$199',
    period: '/month',
    features: ['Review follow-up system', 'Google review link', 'Monthly reporting', 'Google Map listing'],
    cta: 'Start with Starter',
    featured: false
  }, {
    name: 'Growth',
    price: '$399',
    period: '/month',
    features: ['Everything in Starter', 'Google Business optimization', 'Google Map listing', 'Review responses', 'SMS automation'],
    cta: 'Choose Growth',
    featured: true
  }, {
    name: 'Premium',
    price: '$699+',
    period: '/month',
    features: ['Full local SEO', 'Website management', 'Social media posting', 'Lead generation', 'Google Map listing'],
    cta: 'Go Premium',
    featured: false
  }];
  return <>
      <section id="pricing" className="py-20 md:py-32 bg-white" data-id="element-268">
        <div className="container mx-auto px-4 md:px-6" data-id="element-269">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-270">
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-navy mb-4" data-id="element-271">
              Simple Monthly Packages
            </h2>
            <p className="text-lg text-muted" data-id="element-272">
              No contracts. Cancel anytime. Pick the plan that fits your
              business.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-273">
            {plans.map((plan, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} whileHover={{
            y: -5
          }} className={`relative bg-white rounded-2xl p-8 shadow-card border ${plan.featured ? 'border-gold shadow-xl md:scale-105 z-10' : 'border-gray-100'}`} data-id="element-274">
                {plan.featured && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold text-navy font-bold text-sm px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-275">
                    Most Popular
                  </div>}

                <div className="mb-8" data-id="element-276">
                  <h3 className="text-2xl font-heading font-bold text-navy mb-2" data-id="element-277">
                    {plan.name}
                  </h3>
                  <div className="flex items-baseline gap-1" data-id="element-278">
                    <span className="text-4xl font-heading font-extrabold text-navy" data-id="element-279">
                      {plan.price}
                    </span>
                    <span className="text-muted font-medium" data-id="element-280">
                      {plan.period}
                    </span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8" data-id="element-281">
                  {plan.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-282">
                      <Check className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-283" />
                      <span className="text-ink text-sm" data-id="element-284">{feature}</span>
                    </li>)}
                </ul>

                <button onClick={() => setSelectedPlan(plan)} className={`w-full py-3.5 px-6 rounded-md font-bold text-sm transition-colors ${plan.featured ? 'bg-navy text-white hover:bg-navy-deep' : 'bg-transparent border-2 border-navy text-navy hover:bg-navy hover:text-white'}`} data-id="element-285">
                  {plan.cta}
                </button>
              </motion.div>)}
          </div>
        </div>
      </section>

      <Modal isOpen={selectedPlan !== null} onClose={() => setSelectedPlan(null)} title={selectedPlan ? `Sign up for ${selectedPlan.name}` : ''} subtitle="Fill out the form below and we'll get you set up." data-id="element-286">
        {selectedPlan && <SignupForm planName={selectedPlan.name} planPrice={selectedPlan.price} onClose={() => setSelectedPlan(null)} data-id="element-287" />}
      </Modal>
    </>;
}